import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { actionTypes, useStateValue } from "../../store";
import Button from "@mui/material/Button";
import Header from "../HIValuePlus/BaseComponents/Header";
import HIFotterMain from "../HIValuePlus/BaseComponents/Footer";
import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  GetHVPGetCategoryList,
  GetHVPGetSubCategoryList,
  GetHVPStateList,
  GetHVPCityList,
  SellProductByCustomer,
  getCustomerProfile,
  SellProductByCustomerSendOTP,
  SellProductByCustomerOTPVerify,
  GetHVPGetModelList,
  getPriceCalculationCriteria,
  GetPriceCalculation,
  GetSellProductByCustomerDetails,
} from "../../networkCalls";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Box,
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Rating,
  Typography,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Modal } from "react-bootstrap";
import { set } from "date-fns";
import { format } from "date-fns";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ReplayIcon from "@mui/icons-material/Replay";
import { se } from "date-fns/locale";

const UploadBox = ({ label, subLabel, onFileSelect, file }) => {
  return (
    <Box>
      <Typography variant="body1" fontWeight="bold" mb={1}>
        {label}
      </Typography>
      <Box
        className="border rounded text-center d-flex flex-column justify-content-center align-items-center position-relative"
        sx={{ cursor: "pointer", minHeight: "140px", p: 2 }}
      >
        {/* <CloudUploadIcon fontSize="large" color="action" /> */}
        {file ? (
          <img src={file} width={200} />
        ) : (
          <>
            <Typography variant="body2" className="mt-2">
              {subLabel}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Drag and drop or click to upload
            </Typography>
          </>
        )}

        {/* Hidden Input for File Selection */}
        {/* <Button
          component="label"
          variant="text"
          className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
        >
          <input
            type="file"
            hidden
            onChange={(e) => {
              if (e.target.files.length > 0) {
                onFileSelect(e.target.files[0]);
              }
            }}
          />
        </Button> */}
      </Box>
    </Box>
  );
};

const validationSchema = yup.object({
  productname: yup.string().required("Product Name is required"),
  yearofmanufacture: yup.string().required("Purchasing Year is required"),
  warranty: yup.string().required("Product Warranty is required"),
  workingcondition: yup
    .string()
    .required("Product Working Condition is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  category: yup.string().required("Product Category is required"),
  subcategory: yup.string().required("Product Sub Category is required"),
  zipcode: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "Pincode must be 6 digits")
    .required("Pincode is required"),
  location: yup.string().required("Address is required"),
  frontImage: yup.mixed().required("Front view image is required"),
  leftImage: yup.mixed().required("Left view image is required"),
  rightImage: yup.mixed().required("Right view image is required"),
  topImage: yup.mixed().required("Top view image is required"),
});
const validationSchema1 = yup.object({
  name: yup.string().required("Name is required"),
  phone: yup.string().required("Phone Number is required"),
  email: yup.string().required("Email is required"),
});
const validationSchema2 = yup.object({
  otp: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "OTP must be 6 digits")
    .required("OTP is required"),
});
const ViewProductHIVALUEPLUS = () => {
  const { pageSlug } = useParams();
  console.log("pageslug", pageSlug);
  const location = useLocation();
  const navigate = useNavigate();
  const [{ token, huid }, dispatch] = useStateValue();
  const [customerData, setCustomerData] = React.useState(null);

  const [errMessage, setErrMessage] = useState("");
  const [dealererrMessage, setDealerErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [sellingId, setSellingId] = useState(null);
  const [show, setShow] = useState(false);
  const [dealershow, setdealerShow] = useState(false);
  const [calculatedPrice, setCalculatedPrice] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const handleClose = () => {
    setShow(false);
    setChangetoOTP(false);
  };
  const handleShow = () => setShow(true);

  const pullCategoryList = () => {
    GetHVPGetCategoryList().then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.categoryList.map((item) => ({
            id: item.id,
            label: item.name,
            image: item.image,
          }));
          setCategoryList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  const [criteriaList, setCriteriaList] = useState([]);
  const pullCriteriaList = (value) => {
    var data = new FormData();
    data.append("category", value);
    getPriceCalculationCriteria(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCriteriaList(res?.data?.PriceCalculationCriteria);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [subCategoryList, setSubcategoryList] = useState([]);
  const pullSubCategoryList = (value) => {
    var data = new FormData();
    data.append("categoryId", value);
    GetHVPGetSubCategoryList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.subCategoryList.map((item) => ({
            id: item.id,
            label: item.name,
            image: item.image,
          }));
          setSubcategoryList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const callApiProfile = () => {
    var data = new FormData();
    data.append("customerId", huid);
    // data.append("XAuth", token);
    // setLoading(true);
    getCustomerProfile(data).then((res) => {
      console.log("getCustomerProfile", res);
      // setLoading(false);
      switch (res.data.status) {
        case 1:
          setCustomerData(res.data.customerData);
          return true;
        case 0:
          setErrMessage(res.data.msz);
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };
  const [stateList, setStateList] = useState([]);
  const pullStateList = () => {
    GetHVPStateList().then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.stateList.map((item) => ({
            id: item.key,
            label: item.name,
          }));
          setStateList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  const [cityList, setCityList] = useState([]);
  const pullCityList = (value) => {
    var data = new FormData();
    data.append("state", value);
    GetHVPCityList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.cityList.map((item) => ({
            id: item.key,
            label: item.name,
          }));
          setCityList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [modelList, setModelList] = useState([]);
  const pullModelList = (value, newvalue) => {
    var data = new FormData();
    data.append("categoryId", value);
    data.append("subCategoryId", newvalue);
    GetHVPGetModelList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.modelListArray.map((item) => ({
            id: item.key,
            label: item.name,
          }));
          setModelList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  console.log("modellist", cityList);
  const [productDatas, setproductData] = useState(null);
  const [initial, setInitial] = useState({
    productname: "",
    yearofmanufacture: "",
    category: "",
    subcategory: "",
    warranty: "",
    workingcondition: "",
    city: "",
    state: "",
    zipcode: "",
    location: "",
    frontImage: null,
    leftImage: null,
    rightImage: null,
    topImage: null,
  });
  const productData = () => {
    var data = new FormData();
    // data.append("XAuth", token);
    data.append("sellingId", pageSlug);
    GetSellProductByCustomerDetails(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const productDetails = res.data.productsDetails;
          setproductData(productDetails);

          // Pre-populate dependent dropdowns before setting initial values
          pullCityList(productDetails.state);
          pullSubCategoryList(productDetails.category);
          pullModelList(productDetails.category, productDetails.subCategory);

          // Update the initial values state which Formik will use to re-initialize
          setInitial({
            productname: productDetails?.productName || "",
            yearofmanufacture: productDetails?.yearOfManufacture || "",
            category: productDetails?.category_name || "",
            subcategory: productDetails?.sub_category_name || "",
            warranty: productDetails?.warranty || "",
            workingcondition: productDetails?.condition || "",
            city: productDetails?.city_name || "",
            state: productDetails?.state || "",
            zipcode: productDetails?.pincode || "",
            location: productDetails?.location || "",
            // Images cannot be pre-filled in a file input for security reasons.
            // They should be reset or handled differently (e.g., showing a preview of the existing image).
            frontImage: productDetails?.image_1 || null,
            leftImage: productDetails?.image_2 || null,
            rightImage: productDetails?.image_3 || null,
            topImage: productDetails?.image_4 || null,
          });
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  useEffect(() => {
    pullStateList();
    pullCategoryList();
    callApiProfile();
    if (pageSlug) {
      productData();
    }
  }, [token, huid, pageSlug]);

  const formik = useFormik({
    initialValues: initial,
    enableReinitialize: true, // This allows Formik to reset when `initialValues` prop changes
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("values", values);
      var data = new FormData();
      data.append("customerId", huid);
      data.append("XAuth", token);
      data.append("productName", values.productname);
      data.append("yearOfManufacture", values.yearofmanufacture);
      data.append("category", values.category);
      data.append("subCategory", values.subcategory);
      data.append("warranty", values.warranty);
      data.append("condition", values.workingcondition);
      data.append("state", values.state);
      data.append("city", values.city);
      data.append("pincode", values.zipcode);
      data.append("location", values.location);
      data.append("image_1", values.frontImage);
      data.append("image_2", values.leftImage);
      data.append("image_3", values.rightImage);
      data.append("image_4", values.topImage);
      SellProductByCustomer(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            console.log("response ", res);
            setDealerList(res.data.dealerList);
            setdealerShow(true);
            setSellingId(res.data.sellingId);
            // handleShow();

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });

  useEffect(() => {
    setCityList([]);
    formik.setFieldValue("city", "");
  }, [formik.values.state]);
  console.log("initial", formik.values, initial);
  /// OTP MODAL "/////" //////
  const [changetoOTP, setChangetoOTP] = useState(false);

  const formikOtp = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: `${customerData?.firstName} ${customerData?.lastName}`,
      phone: `${customerData?.phone}`,
      email: `${customerData?.email}`,
    },
    validationSchema: validationSchema1,
    onSubmit: (values) => {
      console.log("values", values);
      const dealer = selected.map((val) => {
        return { dealerId: val.dealerid };
      });
      var data = new FormData();
      data.append("customerId", huid);
      // data.append("XAuth", token);
      data.append("name", values.name);
      data.append("phone", values.phone);
      data.append("email", values.email);
      data.append("dealerList", JSON.stringify(dealer));
      data.append("sellingId", sellingId);
      SellProductByCustomerSendOTP(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setSellingId(res.data.sellingId);
            setChangetoOTP(true);

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });
  const formikOtpVerify = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      console.log("values", values);
      var data = new FormData();
      data.append("customerId", huid);
      // data.append("XAuth", token);
      data.append("otp", values.otp);
      data.append("sellingId", sellingId);
      SellProductByCustomerOTPVerify(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setSellingId(res.data.sellingId);
            setChangetoOTP(false);
            navigate("/myaccount/sell-your-product");

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
      // setChangetoOTP(true);
    },
  });
  /// OTP MODAL "/////" //////

  const [modalshow, setModalShow] = useState(false);
  const [value, setValue] = React.useState(null);

  const [startdate, setStartDate] = React.useState(null);
  const handleChange = (newValue) => {
    console.log("newValue", newValue, format(newValue, "yyyy-MM-dd"));
    setValue(newValue);

    setStartDate(format(newValue, "yyyy-MM-dd"));
  };
  const [invoiceAmount, setInvoiceAmount] = useState("");

  // ⭐ Update rating when user clicks
  const handleRatingChange = (sectionIndex, rowIndex, newValue) => {
    setCriteriaList((prev) =>
      prev.map((section, sIdx) =>
        sIdx === sectionIndex
          ? {
              ...section,
              List: section.List.map((row, rIdx) =>
                rIdx === rowIndex ? { ...row, star: newValue } : row
              ),
            }
          : section
      )
    );
  };
  const handleSubmitCalculation = (e) => {
    e.preventDefault();
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    data.append("category", formik.values.category);
    data.append("invoiceDate", startdate);
    data.append("invoicePrice", invoiceAmount);
    data.append("criteria", JSON.stringify(criteriaList));
    GetPriceCalculation(data)
      .then((res) => {
        console.log("res", res);
        res.data.status === 1 ? setModalShow(false) : setModalShow(true);
        res.data.status === 1
          ? setCalculatedPrice(res.data.Price)
          : setCalculatedPrice("");
      })
      .catch((err) => {});
    console.log("data", data, JSON.stringify(criteriaList));
  };
  const commonTextFieldStyles = {
    "& .MuiOutlinedInput-root": {
      height: 40, // Set your desired fixed height
      "& fieldset": {
        borderRadius: "6px", // Consistent border radius
      },
    },
  };
  const [selected, setSelected] = useState([]);

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((d) => d.id !== id.id) : [...prev, id]
    );
  };
  return (
    <>
      <Header />

      <div className="innerpagebg pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-9 text-left m-auto">
              <div className="d-flex align-items-center">
                <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                  <span className="texthivalueplus">My </span>{" "}
                  <span className="txtdgray">Product</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-9 col-md-12 col-12 m-auto">
              {errMessage ? <Alert severity="error">{errMessage}</Alert> : null}
              {susMessage ? (
                <Alert severity="success">{susMessage}</Alert>
              ) : null}
              <div className="card p-4 mb-3">
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                  <div className="row">
                    {/* Category */}
                    <div className="col-lg-6 col-md-6 col-12">
                    <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="category"
                        name="category"
                        label="Category"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.category}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                     
                    </div>
   {/* { Modal Name} */}
                    <div className="col-lg-6 col-md-6 col-12">
                    <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="productname"
                        name="productname"
                        label="Model Name"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.productname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                      
                    </div>
                    {/* Sub Category */}
                    <div className="col-lg-6 col-md-6 col-12">
                     <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="subcategory"
                        name="subcategory"
                        label="Sub Category"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.subcategory}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                      
                    </div>
                 
                    {/* Year of Manufacture */}
                    <div className="col-lg-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="yearofmanufacture"
                        name="yearofmanufacture"
                        label="Year of Purchase"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.yearofmanufacture}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                    </div>

                    {/* Warranty */}
                    <div className="col-lg-6 col-12">
                      <div className="row">
                        <div className="col-6">
                          <Autocomplete
                            disablePortal
                            id="underwarranty"
                            options={[
                              { label: "Yes", id: 1 },
                              { label: "No", id: 2 },
                            ]}
                            value={
                              initial.warranty === "Expired"
                                ? { label: "No", id: 2 }
                                : { label: "Yes", id: 1 }
                            }
                            onChange={(e, value) => {
                              formik.setFieldValue(
                                "underwarranty",
                                value?.label || ""
                              );
                              // pullCityList(value?.label);
                              //   setCityList([]);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("underwarranty", true)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                className="mb-4 w-100 "
                                label="Under Warranty"
                                
                              />
                            )}
                          />
                        </div>
                        <div className="col-6">
                          <TextField
                            className="mb-4 w-100"
                            variant="standard"
                            id="warranty"
                            name="warranty"
                            label="Warranty Expiry Date"
                            type="text"
                            InputProps={{
                              readOnly: true,
                            }}
                            value={initial.warranty ==="Expired" ? "DD-MM-YYYY" : initial.warranty}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            
                          />
                        </div>
                      </div>
                    </div>

                    {/* Working Condition */}
                    <div className="col-lg-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="workingcondition"
                        name="workingcondition"
                        label="Enter Working Condition *"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.workingcondition}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                    </div>

                    {/* State */}
                    <div className="col-lg-6 col-md-6 col-12">
                     <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="state"
                        name="state"
                        label="State"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.state}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                      
                    </div>

                    {/* City */}
                    <div className="col-lg-6 col-md-6 col-12">
                     <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="city"
                        name="city"
                        label="City"
                        type="text"
                        InputProps={{
                          readOnly: true,
                        }}
                        value={initial.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                       
                      />
                    </div>

                    {/* Location */}
                    <div className="col-lg-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="location"
                        name="location"
                        label="Location *"
                        type="text"
                        value={initial.location}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                          readOnly: true,
                        }}
                       
                      />
                    </div>

                    {/* Zipcode */}
                    <div className="col-lg-6 col-md-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="zipcode"
                        name="zipcode"
                        inputProps={{ maxLength: 6 }}
                        label="Pincode *"
                        type="text"
                        value={initial.zipcode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                          readOnly: true,
                        }}
                       
                      />
                    </div>

                    {/* Uploads */}
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Cover View Image*"
                        subLabel="Upload cover view of the product"
                        file={initial.frontImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("frontImage", file)
                        }
                      />
                     
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Front View Image*"
                        subLabel="Upload Front view of the product"
                        file={initial.leftImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("leftImage", file)
                        }
                      />
                     
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Top View Image*"
                        subLabel="Upload Top view of the product"
                        file={initial.rightImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("rightImage", file)
                        }
                      />
                     
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Side View Image*"
                        subLabel="Upload side view of the product"
                        file={initial.topImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("topImage", file)
                        }
                      />
                     
                    </div>
                    {/* Submit */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => handleClose()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 m-5">
            <div className="row">
              <div className="col-12">
                <h4 className=" m-0 fw-bold text-uppercase text-center">
                  <span className="txtdgray">OTP Verification</span>
                </h4>
              </div>
              {changetoOTP ? (
                <form
                  className="col-12"
                  onSubmit={formikOtpVerify.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-3">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="otp"
                        name="otp"
                        label="Enter 6 digit code *"
                        type="text"
                        value={formikOtpVerify.values.otp}
                        onChange={formikOtpVerify.handleChange}
                        onBlur={formikOtpVerify.handleBlur}
                        error={
                          formikOtpVerify.touched.otp &&
                          Boolean(formikOtp.errors.otp)
                        }
                        helperText={
                          formikOtpVerify.touched.otp &&
                          formikOtpVerify.errors.otp
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                        // onClick={() => {
                        //   setShow(true);
                        // }}
                      >
                        Verify
                      </Button>
                    </div>
                  </div>
                </form>
              ) : (
                <form
                  className="col-12"
                  onSubmit={formikOtp.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-3">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="name"
                        name="name"
                        label="Your Name *"
                        type="text"
                        value={formikOtp.values.name}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.name &&
                          Boolean(formikOtp.errors.name)
                        }
                        helperText={
                          formikOtp.touched.name && formikOtp.errors.name
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="phone"
                        name="phone"
                        label="Phone Number *"
                        type="text"
                        value={formikOtp.values.phone}
                        onChange={formikOtp.handleChange}
                        disabled
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.phone &&
                          Boolean(formikOtp.errors.phone)
                        }
                        helperText={
                          formikOtp.touched.phone && formikOtp.errors.phone
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="email"
                        name="email"
                        label="Email *"
                        type="text"
                        value={formikOtp.values.email}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.email &&
                          Boolean(formikOtp.errors.email)
                        }
                        helperText={
                          formikOtp.touched.email && formikOtp.errors.email
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                        // onClick={() => {
                        //   setShow(true);
                        // }}
                      >
                        Get OTP
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={dealershow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => {
          setdealerShow(false);
        }}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className="  mx-4 mt-2  px-0">
          <span className="hivalueplusmodalheader">Dealer’s List</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="px-3 mt-3">
            <div className="row">
              <form
                className="col-12"
                // onSubmit={formikOtpVerify.handleSubmit}
                autoComplete="off"
              >
                <div>
                  <FormGroup>
                    {dealerList.map((dealer) => {
                      const isSelected = selected.includes(dealer);

                      return (
                        <Card
                          key={dealer.dealerid}
                          variant=""
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1.5,
                            p: 2,
                            // mb: 2,
                          }}
                        >
                          {/* Checkbox */}
                          <Checkbox
                            checked={isSelected}
                            onChange={() => handleSelect(dealer)}
                            sx={{
                              color: "grey.400",
                              "&.Mui-checked": { color: "primary.main" },
                              alignSelf: "flex-start",
                            }}
                          />

                          {/* Dealer Info */}
                          <Card
                            variant="outlined"
                            sx={{
                              // border: "gray",
                              borderRadius: 2,
                              borderWidth: 2,
                              p: 2,

                              borderColor: isSelected
                                ? "primary.main"
                                : "grey.300",
                              boxShadow: isSelected ? 3 : 0,
                              transition: "0.2s",
                              flexGrow: 1,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: "bold",
                                color: "#0873bb",
                                mb: 0.5,
                                textTransform: "uppercase",
                              }}
                            >
                              {dealer.dealerName}
                            </Typography>

                            <Typography variant="body2" sx={{ mb: 0.3 }}>
                              <strong>Address:</strong> {dealer.dealerAddress2}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.3 }}>
                              <strong>Pin Code:</strong> {dealer.dealerPinCode}
                            </Typography>
                          </Card>
                        </Card>
                      );
                    })}
                  </FormGroup>
                </div>
                {dealererrMessage !== "" ? (
                  <Alert className="text-center" severity="error">
                    {dealererrMessage}
                  </Alert>
                ) : null}
                <div className="col-lg-12 col-12">
                  <div className="relative w-full d-flex justify-content-center mb-3">
                    <Button
                      variant="contained"
                      className="hivalueplusSubmitBtn"
                      // type="submit"
                      onClick={() => {
                        if (selected.length > 0) {
                          setShow(true);
                          setdealerShow(false);
                        } else {
                          setDealerErrMessage(
                            "Please Select atleast one dealer"
                          );
                        }
                      }}
                    >
                      Select & Next
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        centered
        show={modalshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded"
        onHide={() => setModalShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className="  mx-4 mt-2  px-0">
          <span className="hivalueplusmodalheader">Price Calculation</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="px-4 pt-3 pb-3 ">
            <div className="d-flex justify-content-between flex-column flex-lg-row gap-3">
              <div className="d-flex flex-column flex-lg-row gap-2 align-items-center hidatediv">
                <p className="hivalueplusmodalheading mb-0">Purchased Date</p>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDatePicker
                    views={["year", "month", "day"]}
                    inputFormat="dd-MM-yyyy"
                    value={value}
                    minDate={new Date("2014-01-01")}
                    maxDate={new Date()}
                    onChange={handleChange}
                    sx={{
                      padding: "8.5px 0",
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{
                          width: 160,

                          // CORRECT: Target the stable class name for the inner container
                          "& .MuiPickersOutlinedInput-sectionsContainer": {
                            // Override the large default padding to match a 'small' TextField
                            padding: "8.5px 14px",
                          },

                          // Optional: Keep your other custom styles
                          "& .MuiOutlinedInput-root fieldset": {
                            borderRadius: 6,
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="d-flex flex-column flex-lg-row gap-2 align-items-center">
                <p className="hivalueplusmodalheading mb-0">Amount</p>
                <TextField
                  id="input-with-icon-textfield"
                  value={invoiceAmount}
                  onChange={(e) => setInvoiceAmount(e.target.value)}
                  sx={commonTextFieldStyles}
                  // label="TextField"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CurrencyRupeeIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    },
                  }}
                  variant="outlined"
                />
              </div>
            </div>
          </div>
          <div className="px-4">
            <div className="row">
              <div className="col-12 ">
                <div className="table-responsive">
                  <table className="table hitable">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Content</th>
                        <th>Criteria</th>
                      </tr>
                    </thead>
                    <tbody>
                      {criteriaList.map((section, sectionIndex) =>
                        section.List.map((row, rowIndex) => (
                          <tr
                            key={`${sectionIndex}-${rowIndex}`}
                            className={
                              section.item === "Hunting"
                                ? "hihighlight-row"
                                : ""
                            }
                          >
                            {rowIndex === 0 && (
                              <td
                                rowSpan={section.List.length}
                                className="hiitem-col"
                              >
                                {section.criteriaName}
                              </td>
                            )}
                            <td>{row.criteriaName}</td>
                            <td>
                              <Rating
                                name={`rating-${sectionIndex}-${rowIndex}`}
                                value={row.star}
                                max={3}
                                onChange={(_, newValue) =>
                                  handleRatingChange(
                                    sectionIndex,
                                    rowIndex,
                                    newValue
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="px-4 pb-3 text-end">
            <button
              className="hipricecalculationbtn"
              onClick={(e) => {
                //  setModalShow(false);
                handleSubmitCalculation(e);
              }}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <HIFotterMain />
    </>
  );
};

export default ViewProductHIVALUEPLUS;
